import { baseUrl } from "@/utils/global";
import axios from "../axios";
import {
    IAiChatStreamParams,
    IAiChatConversationListData
} from "./aiChat.types";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { tokenManager } from "@/utils/auth";

export interface IAiChatStreamOptions {
    onopen,
    onmessage
    onerror
    onclose
}

export function aiChatStream(params: IAiChatStreamParams, options: IAiChatStreamOptions) {
    const {
        onopen,
        onmessage,
        onerror,
        onclose,
    } = options
    let token = tokenManager.getValue()
    return fetchEventSource(baseUrl + '/ai/chat/stream', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8', // 明确UTF-8
            'Accept': 'text/event-stream; charset=utf-8',
            token,
        },
        body: JSON.stringify(params),
        credentials: 'same-origin',
        onopen,
        onmessage,
        onerror,
        onclose,
    })
}

export function aiChatConversationDelete(conversationId) {
    return axios({
        method: 'delete',
        url: `/ai/chat/conversation/${conversationId}`,
    })
}


export function aiChatConversationList() {
    return axios<IAiChatConversationListData>({
        method: 'get',
        url: "/ai/chat/conversation/list",
    })
}


export function aiChatConversationMessageGet(conversationId) {
    return axios({
        method: 'get',
        url: `/ai/chat/conversation/messages/${conversationId}`,
    })
}
